@if (systemErrorNotificationsComputed() && systemErrorNotificationsComputed().length > 0) {
  @for (notification of systemErrorNotificationsComputed(); track $index) {
    <div class="card-style mb-3 rounded-box px-4 py-2">

      <div class="flex w-full flex-row justify-between">
        <div class="error-text mb-2 flex flex-row gap-2 text-lg">
          <span aria-hidden="true" class="error-icon">
            <i class="fa-regular fa-circle-xmark text-xl"></i>
          </span>
          <div class="font-semibold">{{ notification.errorCode }}</div>
        </div>
        <div class="flex items-start">
          <label class="mr-3 text-xs">{{ notification.timestamp }}</label>
          <button type="button" class="daisy-btn daisy-btn-ghost daisy-btn-circle daisy-btn-xs opacity-50 hover:opacity-100"
            aria-label="Dismiss" daisyTooltip="Dismiss" [daisyTooltipDelay]="750"
            (click)="onRemoveSystemNotificationClick(notification)">
            <i class="fa-light fa-xmark"></i>
          </button>
        </div>
      </div>

      <div class="flex w-full flex-col gap-2">
        <div>{{ notification.detail }}</div>
        <div class="error-text mt-1 flex w-full flex-row items-center justify-between opacity-90">
          <label class="text-xs">Operation Id</label>

          <div class="flex items-center">
            @if (notification.isOperationIdCopied) {
              <label class="mr-3 text-xs">Copied!</label>
            }
            @else {
              <button type="button" class="daisy-btn daisy-btn-ghost daisy-btn-circle daisy-btn-xs mr-1 opacity-50 hover:opacity-100"
                aria-label="Copy Operation Id" daisyTooltip="Copy Operation Id" daisyTooltipPosition="left" [daisyTooltipDelay]="750"
                (click)="onCopyOperationIdClick(notification)">
                <i class="fa-light fa-copy"></i>
              </button>
            }
            <small class="text-xs">{{ notification.operationId }}</small>
          </div>
        </div>
      </div>

    </div>
  }
}

@if (systemNotificationsComputed() && systemNotificationsComputed().length > 0) {
  @for (systemNotification of systemNotificationsComputed(); track $index) {
    <div class="notification mb-2 rounded-box" tabindex="0" [ngClass]="systemNotification.isRead ? 'read' : 'unread'">
      <div class="flex flex-col items-start px-4 py-2">
        <span class="flex w-full items-center">
          <daisy-avatar class="shrink-0" [initials]="(systemNotification.sender?.firstInitial ?? '') + (systemNotification.sender?.lastInitial ?? '')" size="2.25rem" shape="rounded" />
          <div class="ml-3 flex w-full flex-col">
            <div class="flex items-start justify-between gap-2">

              <div class="mt-1">
                <span class="mr-1">
                  {{ systemNotification.content?.primaryText }}
                </span>

                @if (systemNotification.content?.tertiaryText) {
                  <a class="cursor-pointer font-bold text-daisy-primary"
                    [routerLink]="'/t/' + authService.userPrincipalComputedSignal()?.currentTenantExternalId + systemNotification.content?.tertiaryUrl"
                    daisyTooltip="Navigate to Release"
                    target="_blank" rel="noopener noreferrer"
                    (click)="onHyperLinkClick(systemNotification, $event)">
                    {{ systemNotification.content?.tertiaryText }}
                  </a>
                }
              </div>

              <div class="-mt-1 h-12 shrink-0">
                @if (systemNotification.isRead) {
                  <button type="button" class="daisy-btn daisy-btn-ghost daisy-btn-circle daisy-btn-sm text-base-content/60"
                    aria-label="Mark as unread" daisyTooltip="Mark as unread"
                    (click)="onMarkNotificationsReadStatusesClick(systemNotification, false, $event)">
                    <i class="fa-regular fa-circle"></i>
                  </button>
                } @else {
                  <button type="button" class="daisy-btn daisy-btn-ghost daisy-btn-circle daisy-btn-sm text-daisy-primary"
                    aria-label="Mark as read" daisyTooltip="Mark as read"
                    (click)="onMarkNotificationsReadStatusesClick(systemNotification, true, $event)">
                    <i class="fa-solid fa-circle"></i>
                  </button>
                }
              </div>

            </div>

            <div class="my-1 flex items-center justify-between">

              <div>
                @if (systemNotification.content?.secondaryText) {
                  <a class="cursor-pointer font-bold text-daisy-primary"
                    [routerLink]="'/t/' + authService.userPrincipalComputedSignal()?.currentTenantExternalId + systemNotification.content?.secondaryUrl"
                    daisyTooltip="Navigate to Release Feed"
                    target="_blank" rel="noopener noreferrer"
                    (click)="onHyperLinkClick(systemNotification, $event)">
                    <i class="fa-solid fa-bars-staggered"></i>
                    {{ systemNotification.content?.secondaryText }}
                  </a>
                }
              </div>

              <span class="text-base-content/60">
                {{ systemNotification.createdOn | timeAgo }}
              </span>

            </div>

          </div>
        </span>
      </div>
    </div>
  }
}
